






































import {Component, Vue} from 'vue-property-decorator';
import ReportContainer from '../../components/report-container/report-container.vue';
import FilterContainer from '../../components/filter-container/filter-container.vue';
import FilterDropDown from '@/modules/neodash/components/filter-form/filter-drop-down/filterDropDown.vue';
import FormPeriod from '@/modules/neodash/components/filter-form/period-form/period-form.vue';
import ReportAppBar from '@/modules/neodash/components/report-app-bar/report-app-bar.vue';
import BigIconPanel from '@/modules/neodash/components/big-icon-panel/big-icon-panel.vue';
import moment from 'moment';
import {i18nMixin} from '@/modules/neodash/mixins';
import {MonthYear, Period, PeriodFormValue} from '../../model/types/interfaces/Period';
import {ReportEnum} from '../../model/types/enums/reportEnum';
import {GET_PERIOD} from '../../store/modules/reports/types';
import {CONFIG} from '@/config';
import {Getter} from 'vuex-class';
import {listAllSaleTypes} from '@/modules/neodash/model/constants/saleType';
import {NameValues, OptionalNameValue} from '@/modules/neodash/model/types/interfaces/NameValue';
import {ServiceHelper} from '@/utils/service.helper';
import {IKeyValues} from '@/interfaces/key-value-interface';
import {SaleTypeEnum} from '@/modules/neodash/model/types/enums/saleTypeEnum';
import {traceLogAccess} from '@/services';
import {ContextEnum} from '@/enums/context.enum';

@Component({
  name: 'FordMarketShareBrand',
  components: { ReportAppBar, FilterDropDown, FormPeriod, FilterContainer, ReportContainer, BigIconPanel }
})
export default class FordMarketShareBrand extends Vue {
  public readonly translate = i18nMixin.methods.i18n;
  public readonly keyLabelSaleType: string = 'Common.RegistrationType';
  public readonly salesTypes: NameValues = [
    { name: 'Varejo', value: SaleTypeEnum.RetailSales },
    { name: 'Direta', value: SaleTypeEnum.DirectSales },
    { name: 'Total', value: SaleTypeEnum.AllOfIt },
  ];

  public chosenPeriod: PeriodFormValue = null;
  public chosenSaleType: OptionalNameValue = null;

  public reportGenerated: boolean = false;
  public isDownloading: boolean = false;
  public filters: IKeyValues = [];

  @Getter(GET_PERIOD)
  public getPeriod: (key: ReportEnum) => Period;

  public get limits(): Period {
    const getMonthYear = (): MonthYear => {
      const finalDate = moment();
      return {
        month: finalDate.month(),
        year: finalDate.year()
      }
    };

    return {
      initial: {
        year: getMonthYear().year - 3,
        month: 1
      },
      final: getMonthYear()
    }
  }

  public get formValid(): boolean {
    const {chosenSaleType} = this;
    if (!chosenSaleType)
      return false;

    return !!chosenSaleType.value;
  }

  public downloadReport() {
    const {chosenPeriod, chosenSaleType} = this;

    if (!chosenPeriod || !chosenSaleType)
      return;

    const params = {
      saleType: chosenSaleType.value,
      dtYearInit: chosenPeriod.value.dtYearInit,
      dtMonthInit: chosenPeriod.value.dtMonthInit,
      dtYearFinal: chosenPeriod.value.dtYearFinal,
      dtMonthFinal: chosenPeriod.value.dtMonthFinal
    };

    this.reportGenerated = true;
    this.isDownloading = true;

    const fileName =`Ford_Share por Cidade_${chosenSaleType.name}_v${moment().format('YYYYMMDD')}.xlsx` ;
    traceLogAccess.logAction(ContextEnum.Report, 'Share por Cidade (Ford) - Download', JSON.stringify(params));

    ServiceHelper.generateFile(`${CONFIG.URL.NEODASH_API}/api/neodash/getExcel/fordMarketShareBrand`, fileName, {
      method: 'post',
      parameters: params
    }).finally(() => {
      this.isDownloading = false;
    });

    this.updateFilters();
  }

  private updateFilters(): void {
    const {chosenPeriod, translate, chosenSaleType, keyLabelSaleType} = this;

    if (!chosenPeriod || !chosenSaleType)
      return;

    this.filters = [
      {text: translate(keyLabelSaleType), value: translate(chosenSaleType.name)},
      {text: translate('Common.Period'), value: translate(chosenPeriod.label)}
    ];
  }
}
